import * as Yup from 'yup';

export const ExperienceSchema = Yup.object().shape({
  title: Yup.string().required('Please enter a title'),
  qualificationCertificate: Yup.mixed()
    .nullable()
    .test('fileFormat', 'Unsupported file format', (value) => {
      if (!value) return true; // allow null or undefined
      if (typeof value === 'string') return true; // allow string values (e.g., URL)
      return value instanceof File;
    })
    .test('fileSize', 'File size must not exceed 3MB', (value) => {
      if (!value) return true; // allow null or undefined
      if (typeof value === 'string') return true; // allow string values (e.g., URL)
      return value instanceof File && value.size <= 3 * 1024 * 1024;
    }),
  companyName: Yup.string().required('Enter a company name'),
  otherQualification: Yup.string().nullable(),
  employmentType: Yup.string().required('Please select type'),
  yearOfQualification: Yup.date().nullable(),
  location: Yup.string().required('Please enter your location'),
  startDate: Yup.string().required('Enter start date'),
  endDate: Yup.string().required('Enter end date'),
  // id: Yup.string(),
});

export type ExperienceDataType = Yup.InferType<typeof ExperienceSchema>;

type InitialValues = {
  title: string;
  qualificationCertificate?: any;
  companyName: string;
  otherQualification?: string;
  employmentType?: string;
  yearOfQualification: string;
  location: string;
  startDate: string;
  endDate: string;
  id?: string;
};

export const experienceInitialValues: InitialValues = {
  title: '',
  qualificationCertificate: null,
  companyName: '',
  otherQualification: '',
  employmentType: '',
  yearOfQualification: '',
  location: '',
  startDate: '',
  endDate: '',
  id: '',
};
